function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("title", null, "background"), React.createElement("rect", {
  x: -1,
  y: -1,
  width: 412,
  height: 667,
  id: "canvas_background",
  fill: "#ffffff"
}), React.createElement("g", {
  id: "canvasGrid",
  display: "none"
}, React.createElement("rect", {
  id: "svg_3",
  width: "100%",
  height: "100%",
  x: 0,
  y: 0,
  strokeWidth: 0,
  fill: "url(#gridpattern)"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("title", null, "Layer 1"), React.createElement("rect", {
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 0.7,
  x: 0.75,
  y: -22.25,
  width: 0,
  height: 1,
  id: "svg_2"
}), React.createElement("line", {
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_1",
  y2: 659.666666,
  x2: 6,
  y1: 4,
  x1: 6,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 1.5,
  stroke: "#000",
  fill: "none"
}), React.createElement("line", {
  stroke: "#000",
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_4",
  y2: 164.789464,
  x2: 402,
  y1: 4,
  x1: 402,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 1.5,
  fill: "none"
}), React.createElement("line", {
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_6",
  y2: 4,
  x2: 403,
  y1: 4,
  x1: 5,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 1.5,
  stroke: "#000",
  fill: "none"
}), React.createElement("path", {
  d: "m5,565l14,16",
  id: "svg_10"
}), React.createElement("path", {
  d: "m5,565l14,16",
  id: "svg_11"
}), React.createElement("line", {
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_5",
  y2: 658.736866,
  x2: 274.578946,
  y1: 658.736866,
  x1: 6.052632,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 1.5,
  stroke: "#000",
  fill: "none"
}), React.createElement("line", {
  stroke: "#000",
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_7",
  y2: 327.947363,
  x2: 402,
  y1: 210.315796,
  x1: 402,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 1.5,
  fill: "none"
}), React.createElement("line", {
  stroke: "#000",
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_8",
  y2: 491.105264,
  x2: 402,
  y1: 373.473697,
  x1: 402,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 1.5,
  fill: "none"
}), React.createElement("path", {
  id: "svg_12",
  d: "m273.84613,659.038269l22.307678,-14.615356"
}), React.createElement("path", {
  id: "svg_13",
  d: "m273.84613,659.038269l22.307678,-14.615356"
}), React.createElement("path", {
  id: "svg_14",
  d: "m273.84613,659.038269l22.307678,-14.615356"
}), React.createElement("path", {
  id: "svg_15",
  d: "m273.84613,659.038269l22.307678,-14.615356"
}), React.createElement("path", {
  id: "svg_16",
  d: "m274.47113,659.663269l22.307678,-14.615356"
}), React.createElement("path", {
  id: "svg_17",
  d: "m274.47113,659.663269l22.307678,-14.615356"
}), React.createElement("path", {
  id: "svg_18",
  d: "m274.47113,659.663269l22.307678,-14.615356"
}), React.createElement("path", {
  id: "svg_19",
  d: "m274.47113,659.663269l22.307678,-14.615356"
}), React.createElement("path", {
  id: "svg_20",
  d: "m274.47113,659.663269l22.307678,-14.615356"
}), React.createElement("path", {
  id: "svg_22",
  d: "m274.47113,659.663269l22.307678,-14.615356"
}), React.createElement("path", {
  id: "svg_27",
  d: "m274.47113,659.663269l22.307678,-14.615356"
}), React.createElement("path", {
  id: "svg_30",
  d: "m274.47113,659.663269l22.307678,-14.615356"
}), React.createElement("path", {
  id: "svg_31",
  d: "m274.47113,659.663269l22.307678,-14.615356"
}), React.createElement("path", {
  id: "svg_32",
  d: "m274.47113,659.663269l22.307678,-14.615356"
}), React.createElement("path", {
  id: "svg_33",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_34",
  d: "m275.95636,662.156982l33.860901,-21.873169"
}), React.createElement("path", {
  id: "svg_35",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_36",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_37",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_38",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_39",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_40",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_41",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_42",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_43",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_44",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_45",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_46",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_54",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_55",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_56",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_57",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_58",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_59",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_60",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_61",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_62",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_72",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_73",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_74",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_75",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_76",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_77",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_78",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_79",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_95",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_106",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_107",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_108",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_127",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_128",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_129",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_151",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_152",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_153",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_160",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_161",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_163",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_164",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_165",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_167",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_168",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_169",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_170",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_171",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_172",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_173",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_174",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_175",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_176",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_177",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_178",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_179",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_180",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_181",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_182",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  id: "svg_183",
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("path", {
  d: "m274.623077,659.934998l32.860901,-20.873169"
}), React.createElement("line", {
  transform: "rotate(2.90804, 291.054, 649.498)",
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_9",
  y2: 639.061856,
  x2: 307.483987,
  y1: 659.934974,
  x1: 274.623068,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 1.5,
  stroke: "#000",
  fill: "none"
}), React.createElement("line", {
  stroke: "#000",
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_21",
  y2: 583.882897,
  x2: 402,
  y1: 515.69568,
  x1: 402,
  fillOpacity: "null",
  strokeOpacity: "null",
  strokeWidth: 1.5,
  fill: "none"
}), React.createElement("line", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 1.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x1: 401.944102,
  y1: 583.332364,
  x2: 341.833098,
  y2: 619.276745,
  id: "svg_23",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  stroke: "#000",
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_24",
  y2: 559.994043,
  x2: 348.666756,
  y1: 490.69573,
  x1: 348.666756,
  fillOpacity: "null",
  strokeOpacity: "null",
  fill: "none",
  strokeDasharray: "2 2",
  strokeWidth: 3
}), React.createElement("line", {
  fill: "none",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x1: 348.61086,
  y1: 559.999073,
  x2: 374.166373,
  y2: 598.887897,
  id: "svg_25",
  strokeLinejoin: "null",
  strokeLinecap: "null",
  strokeDasharray: "2 2",
  strokeWidth: 3
}), React.createElement("line", {
  fill: "none",
  stroke: "#000",
  strokeOpacity: "null",
  fillOpacity: "null",
  x1: 348.488379,
  y1: 490.697648,
  x2: 372.674425,
  y2: 490.697648,
  id: "svg_26",
  strokeLinejoin: "null",
  strokeLinecap: "null",
  strokeDasharray: "2 2",
  strokeWidth: 3
}), React.createElement("g", {
  id: "svg_63"
}, React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 342.368817,
  y: 30.214971,
  width: 9.999997,
  height: 3.529411,
  id: "svg_47"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 342.957052,
  y: 83.380061,
  width: 9.999997,
  height: 3.529411,
  id: "svg_48"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 326.588346,
  y: 42.352931,
  width: 4.117646,
  height: 11.176468,
  id: "svg_49"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 326.588346,
  y: 63.074681,
  width: 4.117646,
  height: 11.176468,
  id: "svg_50"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 365.60971,
  y: 63.319552,
  width: 4.117646,
  height: 11.176468,
  id: "svg_51"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 365.60971,
  y: 42.352931,
  width: 4.117646,
  height: 11.176468,
  id: "svg_52"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.8,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 335.060756,
  y: 38.152606,
  width: 26.506021,
  height: 41.3556,
  id: "svg_53"
})), React.createElement("g", {
  id: "svg_71"
}, React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 343.261674,
  y: 105.338533,
  width: 9.999997,
  height: 3.529411,
  id: "svg_64"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 343.849909,
  y: 158.503623,
  width: 9.999997,
  height: 3.529411,
  id: "svg_65"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 327.481204,
  y: 117.476493,
  width: 4.117646,
  height: 11.176468,
  id: "svg_66"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 327.481204,
  y: 138.198242,
  width: 4.117646,
  height: 11.176468,
  id: "svg_67"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 366.502568,
  y: 138.443113,
  width: 4.117646,
  height: 11.176468,
  id: "svg_68"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 366.502568,
  y: 117.476493,
  width: 4.117646,
  height: 11.176468,
  id: "svg_69"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.8,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 335.953614,
  y: 113.276168,
  width: 26.506021,
  height: 41.3556,
  id: "svg_70"
})), React.createElement("g", {
  id: "svg_87"
}, React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 247.011571,
  y: 439.686685,
  width: 9.999997,
  height: 3.529411,
  id: "svg_80"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 247.599806,
  y: 492.851775,
  width: 9.999997,
  height: 3.529411,
  id: "svg_81"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 231.231101,
  y: 451.824646,
  width: 4.117646,
  height: 11.176468,
  id: "svg_82"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 231.231101,
  y: 472.546395,
  width: 4.117646,
  height: 11.176468,
  id: "svg_83"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 270.252465,
  y: 472.791266,
  width: 4.117646,
  height: 11.176468,
  id: "svg_84"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 270.252465,
  y: 451.824646,
  width: 4.117646,
  height: 11.176468,
  id: "svg_85"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.8,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 239.703511,
  y: 447.62432,
  width: 26.506021,
  height: 41.3556,
  id: "svg_86"
})), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 359.74474,
  y: 506.079281,
  width: 4.117646,
  height: 11.176468,
  id: "svg_96"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 359.74474,
  y: 526.80103,
  width: 4.117646,
  height: 11.176468,
  id: "svg_97"
}), React.createElement("g", {
  id: "svg_98"
}, React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 247.011571,
  y: 523.346174,
  width: 9.999997,
  height: 3.529411,
  id: "svg_88"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 247.599806,
  y: 576.511264,
  width: 9.999997,
  height: 3.529411,
  id: "svg_89"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 231.231101,
  y: 535.484135,
  width: 4.117646,
  height: 11.176468,
  id: "svg_90"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 231.231101,
  y: 556.205884,
  width: 4.117646,
  height: 11.176468,
  id: "svg_91"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 270.252465,
  y: 556.450755,
  width: 4.117646,
  height: 11.176468,
  id: "svg_92"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 270.252465,
  y: 535.484135,
  width: 4.117646,
  height: 11.176468,
  id: "svg_93"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.8,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 239.703511,
  y: 531.283809,
  width: 26.506021,
  height: 41.3556,
  id: "svg_94"
})), React.createElement("g", {
  id: "svg_99"
}, React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 51.119296,
  y: 34.583424,
  width: 7.966549,
  height: 148.333288,
  id: "p17b"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 59.568797,
  y: 34.583424,
  width: 7.966549,
  height: 148.333288,
  id: "p17a"
})), React.createElement("g", {
  id: "svg_102"
}, React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 90.405034,
  y: 34.583424,
  width: 7.966549,
  height: 148.333288,
  id: "p16b"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 98.854535,
  y: 34.583424,
  width: 7.966549,
  height: 148.333288,
  id: "p16a"
})), React.createElement("g", {
  id: "svg_105"
}, React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 130.583629,
  y: 34.583424,
  width: 7.966549,
  height: 148.333288,
  id: "p15a"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 139.03313,
  y: 34.583424,
  width: 7.966549,
  height: 148.333288,
  id: "p15b"
})), React.createElement("g", {
  id: "svg_111"
}, React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 171.693393,
  y: 34.583424,
  width: 7.966549,
  height: 99.761804,
  id: "p14b"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 180.142894,
  y: 34.583424,
  width: 7.966549,
  height: 99.761804,
  id: "p14a"
})), React.createElement("g", {
  id: "svg_114"
}, React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 210.97913,
  y: 34.583424,
  width: 7.966549,
  height: 148.333288,
  id: "p13b"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 219.428631,
  y: 34.583424,
  width: 7.966549,
  height: 148.333288,
  id: "p13a"
})), React.createElement("g", {
  id: "svg_117"
}, React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 251.157725,
  y: 34.583424,
  width: 7.966549,
  height: 148.333288,
  id: "p12b"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 259.607226,
  y: 34.583424,
  width: 7.966549,
  height: 148.333288,
  id: "p12a"
})), React.createElement("g", {
  id: "svg_120"
}, React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 51.119296,
  y: 235.484498,
  width: 7.966549,
  height: 148.333288,
  id: "p11b"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 59.568797,
  y: 235.484498,
  width: 7.966549,
  height: 148.333288,
  id: "p11a"
})), React.createElement("g", {
  id: "svg_123"
}, React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 90.405034,
  y: 235.484498,
  width: 7.966549,
  height: 148.333288,
  id: "p10b"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 98.854535,
  y: 235.484498,
  width: 7.966549,
  height: 148.333288,
  id: "p10a"
})), React.createElement("g", {
  id: "svg_126"
}, React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 130.583629,
  y: 235.484498,
  width: 7.966549,
  height: 148.333288,
  id: "p9b"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 139.03313,
  y: 235.484498,
  width: 7.966549,
  height: 148.333288,
  id: "p9a"
})), React.createElement("g", {
  id: "svg_150"
}, React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 171.693393,
  y: 236.488401,
  width: 7.966549,
  height: 99.761804,
  id: "p8b"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 180.142894,
  y: 236.488401,
  width: 7.966549,
  height: 99.761804,
  id: "p8a"
})), React.createElement("g", {
  id: "svg_132"
}, React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 210.97913,
  y: 235.484498,
  width: 7.966549,
  height: 148.333288,
  id: "p7b"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 219.428631,
  y: 235.484498,
  width: 7.966549,
  height: 148.333288,
  id: "p7a"
})), React.createElement("g", {
  id: "svg_135"
}, React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 251.157725,
  y: 235.484498,
  width: 7.966549,
  height: 148.333288,
  id: "p6b"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 259.607226,
  y: 235.484498,
  width: 7.966549,
  height: 148.333288,
  id: "p6a"
})), React.createElement("g", {
  id: "svg_156"
}, React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 291.157768,
  y: 235.484498,
  width: 7.966549,
  height: 148.333288,
  id: "p5b"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 299.607269,
  y: 235.484498,
  width: 7.966549,
  height: 148.333288,
  id: "p5a"
})), React.createElement("g", {
  id: "svg_138"
}, React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 51.119296,
  y: 435.48467,
  width: 7.966549,
  height: 148.333288,
  id: "p4b"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 59.568797,
  y: 435.48467,
  width: 7.966549,
  height: 148.333288,
  id: "p4a"
})), React.createElement("g", {
  id: "svg_141"
}, React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 90.405034,
  y: 435.48467,
  width: 7.966549,
  height: 148.333288,
  id: "p3b"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 98.854535,
  y: 435.48467,
  width: 7.966549,
  height: 148.333288,
  id: "p3a"
})), React.createElement("g", {
  id: "svg_144"
}, React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 130.583629,
  y: 435.48467,
  width: 7.966549,
  height: 148.333288,
  id: "p2b"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 139.03313,
  y: 435.48467,
  width: 7.966549,
  height: 148.333288,
  id: "p2a"
})), React.createElement("g", {
  id: "svg_147"
}, React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 171.693393,
  y: 435.48467,
  width: 7.966549,
  height: 148.333288,
  id: "p1b"
}), React.createElement("rect", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x: 180.142894,
  y: 435.48467,
  width: 7.966549,
  height: 148.333288,
  id: "p1a"
})), React.createElement("path", {
  id: "svg_184",
  d: "m308.964142,642.923279l3.124969,-18.749756"
}), React.createElement("path", {
  id: "svg_185",
  d: "m308.519714,641.590088l3.124969,-18.749756"
}), React.createElement("path", {
  id: "svg_186",
  d: "m307.186432,639.368103l3.124969,-18.749756"
}), React.createElement("path", {
  id: "svg_187",
  d: "m307.186432,639.368103l3.124969,-18.749756"
}), React.createElement("path", {
  id: "svg_188",
  d: "m307.186432,639.368103l3.124969,-18.749756"
}), React.createElement("path", {
  id: "svg_189",
  d: "m309.408569,640.256958l3.124969,-18.749756"
}), React.createElement("path", {
  id: "svg_190",
  d: "m309.408569,640.256958l3.124969,-18.749756"
}), React.createElement("path", {
  id: "svg_191",
  d: "m309.408569,640.256958l3.124969,-18.749756"
}), React.createElement("path", {
  id: "svg_192",
  d: "m309.408569,640.256958l3.124969,-18.749756"
}), React.createElement("path", {
  id: "svg_193",
  d: "m309.408569,640.256958l3.124969,-18.749756"
}), React.createElement("path", {
  id: "svg_194",
  d: "m309.408569,640.256958l3.124969,-18.749756"
}), React.createElement("path", {
  id: "svg_195",
  d: "m309.408569,640.256958l3.124969,-18.749756"
}), React.createElement("path", {
  id: "svg_196",
  d: "m309.408569,640.256958l3.124969,-18.749756"
}), React.createElement("path", {
  id: "svg_197",
  d: "m309.408569,640.256958l3.124969,-18.749756"
}), React.createElement("path", {
  id: "svg_198",
  d: "m309.408569,640.256958l3.124969,-18.749756"
}), React.createElement("path", {
  id: "svg_199",
  d: "m309.408569,640.256958l3.124969,-18.749756"
}), React.createElement("path", {
  id: "svg_200",
  d: "m309.408569,640.256958l3.124969,-18.749756"
}), React.createElement("path", {
  id: "svg_201",
  d: "m309.408569,640.256958l3.124969,-18.749756"
}), React.createElement("path", {
  id: "svg_202",
  d: "m309.408569,640.256958l3.124969,-18.749756"
}), React.createElement("path", {
  id: "svg_203",
  d: "m309.408569,640.256958l3.124969,-18.749756"
}), React.createElement("path", {
  id: "svg_204",
  d: "m309.408569,640.256958l3.124969,-18.749756"
}), React.createElement("path", {
  d: "m309.408569,640.256958l3.124969,-18.749756"
}), React.createElement("path", {
  d: "m309.408569,640.256958l3.124969,-18.749756"
}), React.createElement("path", {
  d: "m309.408569,640.256958l3.124969,-18.749756"
}), React.createElement("path", {
  d: "m309.408569,640.256958l3.124969,-18.749756"
}), React.createElement("line", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x1: 309.40856,
  y1: 640.256962,
  x2: 312.533526,
  y2: 621.507174,
  id: "svg_157",
  strokeLinejoin: "null",
  strokeLinecap: "null",
  transform: "rotate(9.58675, 310.971, 630.882)"
}), React.createElement("line", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x1: 342.000002,
  y1: 619,
  x2: 322.811258,
  y2: 615.618362,
  id: "svg_158",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("line", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x1: 401.452263,
  y1: 210.427631,
  x2: 389.600409,
  y2: 195.612813,
  id: "svg_159",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("path", {
  id: "svg_205",
  d: "m403.93161,165.580612l-13.157867,13.683914"
}), React.createElement("path", {
  id: "svg_206",
  d: "m401.578705,164.404175l-13.157867,13.683929"
}), React.createElement("path", {
  id: "svg_207",
  d: "m402.755188,164.992386l-13.157867,13.683929"
}), React.createElement("path", {
  id: "svg_208",
  d: "m402.755188,164.992386l-13.157867,13.683929"
}), React.createElement("path", {
  id: "svg_209",
  d: "m402.755188,249.069244l-13.157867,13.684204"
}), React.createElement("path", {
  d: "m402.755188,249.069244l-13.157867,13.684204"
}), React.createElement("path", {
  d: "m402.755188,249.069244l-13.157867,13.684204"
}), React.createElement("path", {
  d: "m402.755188,327.956207l-13.157867,13.684204"
}), React.createElement("line", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x1: 402.755186,
  y1: 327.956218,
  x2: 389.597309,
  y2: 341.64041,
  id: "svg_162",
  strokeLinejoin: "null",
  strokeLinecap: "null",
  transform: "rotate(-0.993197, 396.176, 334.798)"
}), React.createElement("line", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x1: 401.452263,
  y1: 373.390589,
  x2: 389.600409,
  y2: 358.575771,
  id: "svg_166",
  strokeLinejoin: "null",
  strokeLinecap: "null"
}), React.createElement("path", {
  d: "m402.755188,249.069244l-13.157867,13.684204"
}), React.createElement("path", {
  d: "m402.755188,249.069244l-13.157867,13.684204"
}), React.createElement("path", {
  d: "m402.755188,327.956207l-13.157867,13.684204"
}), React.createElement("line", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  strokeOpacity: "null",
  fillOpacity: "null",
  x1: 402.755186,
  y1: 327.956218,
  x2: 389.597309,
  y2: 341.64041,
  id: "svg_211",
  strokeLinejoin: "null",
  strokeLinecap: "null",
  transform: "rotate(-0.993197, 396.176, 334.798)"
}), React.createElement("path", {
  id: "svg_217",
  d: "m402.755188,327.956207l-13.157867,13.684204"
}), React.createElement("line", {
  strokeLinecap: "null",
  strokeLinejoin: "null",
  id: "svg_219",
  y2: 177.220329,
  x2: 389.16468,
  y1: 164.998238,
  x1: 401.942322,
  fillOpacity: "null",
  strokeWidth: 0.5,
  stroke: "#000000",
  fill: "none"
}));

var SvgCeresCn = function SvgCeresCn(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "90vw",
    height: "80vh",
    viewBox: "0 0 410 665",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCeresCn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ceres-cn.6323a2ee.svg";
export { ForwardRef as ReactComponent };